import { action, makeObservable, observable } from "mobx";
import { gameModuleService } from "../services/gameModuleService";
import { GAME_SPEED_TYPES } from "../../constants/gameConstants";


class GameModuleStore {
    initialMatrix = [];
    resultMatrix = []
    doSpin = null;
    soundService = null;
    animationEnd = null;
    spinSpeedType = 'standard';
    spinDirection = 1;
    additional = null;
    wins = [];
    isForceStop = false;
    awaitForceStop = false;
    canTouchControl = true;
    winAnimations = [];
    responseReady = false;
    hasJackpot = false;
    scatter1Count = 0;


    constructor() {
        makeObservable(this, {
            initialMatrix: observable,
            additional: observable,
            doSpin: observable,
            soundService: observable,
            animationEnd: observable,
            spinSpeedType: observable,
            spinDirection: observable,
            isForceStop: observable,
            awaitForceStop: observable,
            canTouchControl: observable,
            winAnimations: observable,
            responseReady: observable,
            scatter1Count: observable,
            resultMatrix: observable,
            getPropsFromFrame: action.bound,
            setSpinSpeedType: action.bound,
            setSpinDirection: action.bound,
            handleReelAnimationEnd: action.bound,
            setResponseReady: action.bound,
            setAdditional: action.bound,
            setIsForceStop: action.bound,
            setCanTouchControl: action.bound,
            setWinAnimations: action.bound,
            setAwaitForceStop: action.bound,
            setScatterCount: action.bound,
            setResultMatrix: action.bound
        })
    }

    getPropsFromFrame = ({ initialMatrix, doSpin, soundService, animationEnd, result }) => {
        this.initialMatrix = initialMatrix;
        this.doSpin = doSpin;
        this.soundService = soundService;
        this.animationEnd = animationEnd;
    }

    setSpinSpeedType = (type) => {
        this.spinSpeedType = type
    }

    setSpinDirection = (direction) => {
        this.spinDirection = direction
    }

    handleReelAnimationEnd = () => {
        const { wins } = this?.additional || {}
        if (this.hasJackpot) {
            gameModuleService.startJackpotSymblsAnimation()
        }
        if (wins?.length) {
            this.wins = wins
            gameModuleService.startWinAnimation(wins)
        }
        else {
            this.animationEnd('noWin')
            this.setCanTouchControl(true)
        }
        this.awaitForceStop = false
        this.isForceStop = false;
        this.setResponseReady(false)

    }

    setResponseReady = (status) => {
        this.responseReady = status
    }

    setAdditional = (additional) => {
        this.additional = additional
    }

    setIsForceStop = (status) => {
        if (this.spinSpeedType === GAME_SPEED_TYPES.turbo || this.isForceStop) return
        this.isForceStop = status;
    }

    setAwaitForceStop = (status) => {
        this.awaitForceStop = status
    }

    setCanTouchControl = (status) => {
        this.canTouchControl = status
    }

    setWinAnimations = (animation) => {
        animation ? this.winAnimations.push(animation) : this.winAnimations = []
    }

    setHasJackpot = (jackpotSymblsCount) => {
        this.hasJackpot = jackpotSymblsCount === 3 ? true : false
    }

    setScatterCount = (type) => {
        switch (type) {
            case 'scatter1':
                this.scatter1Count += 1;
                break;
            case 'reset':
                this.scatter1Count = 0;
                break

        }
    }

    setResultMatrix = (matrix) => {
        this.resultMatrix = matrix;
    };

}

export const gameModuleStore = new GameModuleStore()